import ApiModule from './index'
import BaseModel from '../../base/BaseModel'
import { _ } from '@iskytrip/sdk'

export class QueryUserInvoiceList extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.USER
		this.url = '/userinvoice/queryUserInvoiceList'
		this.desc = '根据用户ID查询发票信息列表'
	}
}

export class AddUserInvoice extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.USER
		this.url = '/userinvoice/addUserInvoice'
		this.desc = '添加发票信息'
	}
}

export class DelUserInvoice extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.USER
		this.url = '/userinvoice/delUserInvoice'
		this.desc = '删除发票信息'
	}
}

export class ModifyUserInvoice extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.USER
		this.url = '/userinvoice/modifyUserInvoice'
		this.desc = '修改发票信息'
	}
}

export class GetPackageDetail extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.USER
		this.url = '/userPackage/getPackageDetail'
		this.desc = '获取权益包详情'
	}
}

export class BoundPackage extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.USER
		this.url = '/userPackage/boundPackage'
		this.desc = '绑定权益卡'
	}
}

export class GiftPackageSign extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.USER
		this.url = '/userPackage/giftPackageSign'
		this.desc = '转赠权益卡参数'
	}
}

export class QueryUserContractList extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.USER
		this.url = '/usercontract/queryUserContractList'
		this.desc = '根据用户ID查询联系人信息列表'
	}
}

export class LoginByPhoneVerifyCode extends BaseModel {
	constructor(props = {}) {
		super(props)

		this.apiModule = ApiModule.USER
		this.url = '/usermanger/loginByPhoneVerifyCode'
		this.desc = '手机验证登录'
	}

	dataformat(data) {
		super.dataformat(data)

		if (+data.resultCode) {
			alert(data.errMsg)
		}

		return data
	}
}

export class GetExpiringEquityId extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/userEquities/getExpiringEquityId'
		this.desc = '根据用户获取最近的权益ID'
	}
}

export class GetUserDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/usermanger/getUserDetail'
		this.desc = '获取用户详情'
	}
}

export class RealNameAuth extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/usermanger/realNameAuth'
		this.desc = '实名认证'
	}
}

export class VipEquitiesDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/userSunriseVip/vipEquitiesDetail'
		this.desc = '券详情'
	}
	dataformat(data) {
		return data
	}
}

export class ApplyVipCode extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/userSunriseVip/ApplyVipCode'
		this.desc = '领取券'
	}
}

export class AddUserCar extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/usercar/addUserCar'
		this.desc = '添加用户车牌信息'
	}

	dataformat(data) {
		return data
	}
}

export class DelUserCar extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/usercar/delUserCar'
		this.desc = '删除用户绑定信息'
	}

	dataformat(data) {
		return data
	}
}

export class QueryUserCarList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/usercar/queryUserCarList'
		this.desc = '根据用户ID查询车牌信息列表'
	}

	dataformat(data) {
		super.dataformat(data)

		let array = []
		if (_.isArray(data.resultData)) {
			array = data.resultData
		}

		return array.map((item) => ({
			id: Math.round(Math.random() * 1e10),
			...item,
		}))
	}
}

export class CheckCarplate extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/usercar/checkCarplate'
		this.desc = '检查车牌是否已存在，code 0:不存在，1：存在'
	}

	dataformat(data) {
		return data
	}
}

export class GetPhoneVerify extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/usermanger/getPhoneVerify'
		this.desc = '手机号获取验证码'
	}

	dataformat(data) {
		return data
	}
}

export class CivilAviationAuthMember extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/userMember/authMember'
		this.desc = '认证获取会员'
	}

	dataformat(json) {
		return json
	}
}

export class GetRedeemByEquity extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/userEquities/getRedeemByEquity'
		this.desc = 'getRedeemByEquity'
	}
}

export class BindMemberEquityCoupon extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/userMember/bindMemberEquityCoupon'
		this.desc = '绑定领取会员权益和优惠券'
	}
}

export class QueryUserDeliveryList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/userdelivery/queryUserDeliveryList'
		this.desc = '地址列表'
	}
}

export class LoginByUnionPayMinApp extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/usermanger/LoginByUnionPayMinApp'
		this.desc = '云闪付小程序授权登录'
	}
}
export class SunrisePhoneVerifyApi extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.USER
		this.url = '/userSunriseVip/sendVipVerifyCode'
		this.desc = '权益兑换发送手机验证码'
	}
}
export class QueryIskytripMember extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.WIRELESS
		this.url = '/userMember/queryIskytripMember'
		this.des = '查询在机场会员详情'
	}
}
